import { FunctionComponent, useEffect } from 'react';

import { SmallTitle, Text } from 'chime-ui/components/Typography';
import { colors } from 'chime-ui/system/colors';

import Header from 'components/Layout/Header';

import { useUserContext } from 'hooks/useUserContext';

import { trackReceiveFromAnyoneClaimInfoPageViewed } from 'utils/segment/trackingEvents';

import ClaimInfoBase from '../ClaimInfoBase';

const ReceiveFromAnyoneClaimInfo: FunctionComponent = () => {
  const [userData] = useUserContext();
  const { amount, name, publicId } = userData;

  useEffect(() => {
    trackReceiveFromAnyoneClaimInfoPageViewed(publicId);
  }, [publicId]);

  return (
    <ClaimInfoBase
      hideSaveCardCheckbox={true}
      claimCTACopy={`Pay ${name} $${amount}`}
      header={<Header showLogin={false} />}
    >
      <SmallTitle>
        You&apos;re paying {name}{' '}
        <Text bold color={colors.darkGreen}>
          ${amount}
        </Text>
      </SmallTitle>
    </ClaimInfoBase>
  );
};

export default ReceiveFromAnyoneClaimInfo;
